import type { LevelDefinition } from '../types';

export const LEVELS: LevelDefinition[] = [
  {
    id: 'level-0',
    index: 0,
    name: '\u062d\u0628',
    theme: 'garden',
    parSeconds: 150,
    map: [
      'đđđđđđđđđđđđđđđđđĔĄēđđđđđđđđđĔĄēđđđđđđđđđđđđđđđđđđđđđđđđ',
      'đđđđđđđđđđđđđđđđđHvąĄĄĄĄĄĄĄĄĄăvĐđđđđđđđđđđđđđđđđđđđđđđđđ',
      'đđđđđđđđđđđđđđđđđĒƟ...........ƟĐđđđđđđđđđđđđđđđđđđđđđđđđ',
      'đĔĄĄĄĄĄĄĄĄĄĄĄĄĄĔđĒ..ƍzzzzzzzƎ..Đđđđđđđđđđđđđđđđđđđđđđđđđ',
      'đĒ.ğ....ğ...ğ.tĐđĒ..78888888ĩ..Đđđđđđđđđđđđđđđđđđđđđđđđđ',
      'đĒ.............ĐđĒ..ūŬŬŬŬŬŬŬū..ąĄēđđđđđđđđđĔĄĄĄĄĄĄĄĄĄĄĄĄ',
      'đĒ..j.......j..ĐđĒj.ŬůůůxůůůŬ.j..ĐđđđđđđđđđĒt.........tv',
      'đĒ..s.ğ.....s..ĐđĒs.ŬůůůůůůůŬ.s..ĐđđđđđđđđđĒ...........ă',
      'đĒğ.....Ĩ..ğ...ąĄă..ŬůůůůůůůŬ....ĐđđđđđđđđđĒ.ƍzzzzzzƎ..Đ',
      'đĒ..................ŬůůůůůůůŬ....ĐđđđđđđđđđĒ.ƀſPŸŸPƀſ..Đ',
      'đĒ.........ğ...ğ,...ūŬŬŬŬŬŬŬū..,.ĐđđđđđđđđđĒ.ƀſƊƋƋƊƀſ..Đ',
      'đĒ..ğ...ğ.........Į..............ĐđđđđđđđđđĒ.ƀſƊƋƋƊƀſ..Đ',
      'đĒ.............ăĄą...............ĐđđđđđđđđđĒ.ƀſƊƋƋƊƀſ..Đ',
      'đĒ.........ğ...ĐđđĄĄĄĄĄĄĄĄĄĄĄą...ąĄĄĄĄĄĄĄĄĄă.ƀſƊƋƋƊƀſ..Đ',
      'đĒt...ğ.......tĐđđđđđđđđđđđđđĒ.Į.............ƀſƊƋƋƊƀſ..Đ',
      'đēĄĄą...ăĄĄĄĄĄĄĔđđđđđđđđđđđđđĒ...............ƀſƊƋƋƊƀſ..Đ',
      'đđđđĐ...ĐđđđđđđđđđđđđđđđđđđđđĒ..t...t...t....ƀſƊƋƋƊƀſ..Đ',
      'ĔĄĄĄă...ąĄĄēđđđđđđđđđđđđđđđđđĒ...............ƀſƊƋƋƊƀſ..Đ',
      'Đvtj.....jtĐđđđđđđđđđđđđđđđđđĒ.j..u...u..j..ĮƀſƊƋƋƊƀſ..Đ',
      'đą.s.....s.ĐđđđđđđđđđđđđđđđđđĒ.s..t...t..s...ƀſƊƋƋƊƀſ..Đ',
      'đĒ.ģ.....ģ.ĐđđđđđđđđđđđđđđđđđĒ.............,.ƀſƊƉƉƊƀſ..Đ',
      'đĒ.Š.....Š.ĐđđđđđđđđđđđđđđđđđĒ......u..................ą',
      'đĒ.š..ĭ..Š.ĐđđđđđđđđđđđđđđđđđĒ..t...t...t...t.........tv',
      'đĒ.Š.....Š.ĐđđđđđđđđđđđđđđđđđĒ.............ăĄĄĄĄĄĄĄĄĄĄĄĄ',
      'đĒ.Š.....Š.ĐđđđđđđđđđđđđđđđđđĒ.............Đđđđđđđđđđđđđ',
      'Ĕă.ģŎŏŏŏŐģ.ĐđđđđđđđđđđđđđđđđđēĄĄĄĄĄĄĄĄĄĄĄĄĄĔđđđđđđđđđđđđ',
      'Đvt.......tĐđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđ',
      'ēĄĄĄĄĄĄĄĄĄĄĔđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđđ',
    ],
    rotations: [
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,2,2,0,0,0,0,0,0,0,0,0,2,2,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,2,2,2,2,2,2,2,2,2,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,2,2,2,2,2,2,2,2,0,0,2,2,2,0,0,0,0,0,0,0,0,0,2,2,2,2,2,2,2,2,2,2,2,2,2],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,1,1,1,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,2,2,0,0,1,1,1,1,1,1,1,1,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,1,2,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,3,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,1,2,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,2,2,2,2,2,2,2,2,2,2,0,0,0,2,0,3,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,1,2,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,3,0,0,0,0,0,0],
      [0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,1,2,0,0,0,0,0,0],
      [2,2,2,2,2,0,0,0,2,2,2,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,3,0,0,0,0,0,0],
      [2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,1,2,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,3,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [2,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    ],
    spawn: { x: 6, y: 24 },
    exit: { x: 49, y: 16 },
    objectiveLabel: '\u0627\u062a\u0628\u0639 \u0627\u0644\u0637\u0631\u064a\u0642',
    introTitle: '\u062d\u0628',
    introMessage: '\u0637\u0631\u064a\u0642 \u064a\u062a\u0644\u0648\u0651\u0649 \u0641\u064a \u062c\u0646\u064a\u0646\u0629 \u0645\u0646\u0633\u064a\u0651\u0629.',
    introHint: '\u0627\u062a\u0628\u0639 \u0627\u0644\u0637\u0631\u064a\u0642 \u0644\u0644\u0634\u0645\u0627\u0644 \u0648\u0628\u0639\u062f \u0644\u0644\u0634\u0631\u0642.',
    completionTitle: '\u0628\u0644\u0627\u0644',
    completionMessage: '\u064a\u0644\u0627 \u0646\u0628\u062f\u0627\u0648...',
    completionHint: '\u0627\u0648\u0635\u0644 \u0644\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0623\u062e\u064a\u0631.',
    objectives: [
      {
        id: 'l2-1',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0627\u0644\u0646\u0648\u0641\u0631',
        message: '\u0646\u062d\u0628\u0643 \u064a\u0627 \u0642\u0644\u0628\u064a\u060c \u062d\u0628\u064a\u062a \u0646\u0628\u062f\u0627 \u0628\u0647\u0627\u0630\u0627 \u0627\u0644\u0643\u0644\u0627\u0645...',
        points: 100,
        position: { x: 8, y: 9 },
      },
      {
        id: 'l2-2',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0642\u0628\u0629 \u0627\u0644\u0648\u0631\u062f',
        message: '\u0645\u0646 \u0648\u0642\u062a \u0645\u0627 \u062a\u0639\u0631\u0641\u0646\u0627\u060c \u062d\u0628\u064a \u0639\u0644\u064a\u0643 \u0645\u0627 \u064a\u0632\u064a\u062f \u0643\u0627\u0646 \u064a\u0643\u0628\u0631 ❤️',
        points: 150,
        position: { x: 24, y: 7 },
      },
      {
        id: 'l2-3',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0634\u062c\u0631 \u0645\u0632\u0647\u0651\u0631',
        message: '\u0639\u0645\u0644\u062a\u0644\u0643 \u0647\u0627\u0644\u0639\u0628\u0629 \u0627\u0644\u0635\u063a\u064a\u0631\u0629\u060c \u0628\u0627\u0634 \u0646\u0642\u0648\u0644\u0643 \u0634\u0648\u064a\u0629 \u0643\u0644\u0645\u0627\u062a...',
        points: 200,
        position: { x: 36, y: 20 },
      },
      {
        id: 'l2-4',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0633\u0631\u0651\u064a',
        message: '\u0648\u0646\u062a\u0645\u0646\u0649 \u062a\u0641\u0647\u0645\u064a ❤️',
        points: 300,
        position: { x: 47, y: 12 },
      },
    ],
  },
  {
    id: 'level-1',
    index: 1,
    name: '\u063a\u0631\u0627\u0645',
    theme: 'garden',
    parSeconds: 90,
    map: [
      '7888888888888888888888888888888888888888',
      'ĳĴ88888888888ĴĴ888888888888888888888888Ĵ',
      'ĳĵť.x...1....ĳĵ.zzzzzzzzzzzzzzzzzzzzzztĳ',
      'ĳĵ.1.Ĺ....Ĺť.ĳĵ....................ť...ĳ',
      'ĳĵ.ť....ť....ĳĵ...ļ..ļ..ļ..ļ..ļ..ļ..ļ..ĳ',
      'ĳĵ...ť......1ĳĵ........ť...............ĳ',
      'ĳĵĽ....1.....ĳĵ.ť....ť...u..ť...ť...ť.tĳ',
      'ĳĵ...ť..ť..Ĺ.ĳĵ........................ĳ',
      'ĳĵ.Ĺ.........ĳĵ...ļ..ļ..ļ..ļ..ļ.ųŴƉƉųŴ.ĳ',
      'ľŀj..ğƆůƇğ..jľŀ.ť...............ŜƙƙƉƙŜ.ĳ',
      'ľŀs..ğƆůƇğ..sľŀ......u.ť..ť.....ŜƉƉƉƉŜtĳ',
      '.....ğƆůƇğ....................ť.ŜƉƉƙƉŜ.ĳ',
      '.....ğƆůƇğ........ļ......ť..u...ŜƙƉƉƙŜ.ĳ',
      '..ť..ğƆůƇğ....ģ........u........ųŴųŴųŴ.ĳ',
      '.....ğƆůƇğ...ť..ť...ť.......ť.........tĳ',
      '.....ğƆůƇğ................ť...ť..j..j..ĳ',
      'ť....ğƆůƇğ....ģ...ļ....u...u...ť.s..s..ĳ',
      '...ť.ğƆůƇğ......ť.......ť..............ĳ',
      '.....ğƆůƇğ..ť........ť.....ť..u..ť.ť..tĳ',
      '.....ğƆůƇğ..ť.ģ........................ĳ',
      '.....ğƆůƇğ........ļ..ļ..ļ..ļ..ļ.tļ..ļ..ĳ',
      '.ť...ğƆůƇğ.........ť...................ĳ',
      '.....ğƆůƇğ....ģ.ť...u....ť...ť....ť...tĳ',
      '.....ğƆůƇğ..ť.........ť................ĳ',
      '..ť..ğğğğğ........ļ..ļ..ļ..ļ..ļ.tļ..ļ..ĳ',
      '..............ģ........................ĳ',
      '.......ťť........ť.ť.....ť....ť...ť...tĳ',
      '.......................................ĳ',
    ],
    rotations: [
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,2,2,2,2,2,2,2,2,2,2,2,2,0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    ],
    spawn: { x: 7, y: 22 },
    exit: { x: 34, y: 10 },
    objectiveLabel: '\u0644\u0642\u0627 \u0627\u0644\u0631\u0633\u0627\u064a\u0644',
    introTitle: '\u063a\u0631\u0627\u0645',
    introMessage: '\u0646\u0648\u0631 \u0627\u0644\u0642\u0645\u0631 \u064a\u063a\u0645\u0631 \u0643\u0644 \u0634\u064a \u0628\u0636\u0648\u0621 \u0641\u0636\u0651\u064a.',
    introHint: '\u0627\u062f\u062e\u0644 \u0644\u0644\u062f\u0627\u0631',
    completionTitle: '\u0628\u0644\u0627\u0644',
    completionMessage: '\u0627\u0646\u062a\u0650 \u0627\u062c\u0645\u0644 \u0648\u062d\u062f\u0629 \u0641\u064a \u0639\u064a\u0646\u064a..',
    completionHint: '\u0627\u062f\u062e\u0644 \u0644\u0644\u062f\u0627\u0631',
    objectives: [
      {
        id: 'l2-1',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0627\u0644\u0645\u0643\u062a\u0628',
        message: '\u0627\u0644\u0633\u0627\u0646 \u0641\u0627\u0644\u0648\u0646\u062a\u0627\u0646 \u0641\u0627\u062a\u060c \u0627\u0645\u0627 \u0627\u0646\u0627 \u0646\u0641\u0636\u0651\u0644 \u0645\u0627 \u0646\u0641\u064a\u062a\u064a\u0647\u0627\u0634...',
        points: 100,
        position: { x: 7, y: 3 },
      },
      {
        id: 'l2-2',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0627\u0644\u0628\u064a\u062a',
        message: '\u0628\u062f\u0627\u0644\u0647\u0627\u060c \u0646\u0641\u0636\u0651\u0644 \u0646\u062d\u0637\u0648 \u064a\u0648\u0645\u0646\u0627 \u0627\u062d\u0646\u0627\u060c \u0644\u062d\u0638\u0629 \u062e\u0627\u0635\u0629 \u0648\u0628\u064a\u0646\u0627\u062a\u0646\u0627\u060c Khawla\'s day..',
        points: 150,
        position: { x: 25, y: 14 },
      },
      {
        id: 'l2-3',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0627\u0644\u062c\u0646\u064a\u0646\u0629',
        message: '\u0646\u062a\u0645\u0646\u0649 \u062a\u0641\u0647\u0645\u064a \u0648\u062a\u0642\u0628\u0644\u064a..',
        points: 200,
        position: { x: 34, y: 12 },
      },
    ],
  },
  {
    id: 'level-2',
    index: 2,
    name: '\u0648\u0639\u062f',
    theme: 'sanctuary',
    parSeconds: 60,
    map: [
      '..ť....ť.ť.....ť.....ť.....ť..',
      'ť.Ĺ.ļ..xxxxx.ļ...xxxxx...ť.ťĹ.',
      '......x.....x.j.x.....x.ļ.....',
      '.ť.ť.x....ť..xsx.......x..ť.ğ.',
      '....x.ť.......x.ť.....ť.x.....',
      'ğ..x.ť..ť.....ƨ..........x...ť',
      '...x...............ť.....x....',
      '.ť.x...ť.....ť.......ťť..x.ğ..',
      '...x.ť...................x..ť.',
      '.ļ.x.....ť............ť..x.ļ..',
      '...x......ť....ť.ť.......x....',
      '....x.ť...ť.............x.ť.ť.',
      '.ļ...x.................x...ť..',
      '..ť...x..........ť....x.......',
      '...ğ...x....ť.ť......x..ť.ļ.ğ.',
      'ť.......x...........x.........',
      '.....ť...x......ť..x.....ť.ť..',
      '...ť.ť....x.......x...ť.ğ...ť.',
      'ğ..........x..ť..x.ť......ť...',
      '..ļ..ť.ğ....x...x...ļ.........',
      '.ť......ť..ť.x.x..ťť..ğ.ť..ğ..',
      '....ť.........x...............',
    ],
    rotations: [
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    ],
    spawn: { x: 14, y: 11 },
    exit: { x: 14, y: 5 },
    objectiveLabel: '\u0644\u0642\u0627 \u0627\u0644\u0631\u0633\u0627\u064a\u0644 ',
    introTitle: '\u0648\u0639\u062f',
    introMessage: '\u064a\u0627\u0633\u0631 \u0630\u0643\u0631\u064a\u0627\u062a.',
    introHint: '\u0644\u0642\u0627 \u0643\u0644 \u0631\u0633\u0627\u0644\u0629',
    completionTitle: '\u0628\u0644\u0627\u0644',
    completionMessage: '\u0643\u0644 \u0647\u0630\u0627 \u0628\u0627\u0634 \u0646\u0642\u0648\u0644\u0643 \u0646\u062d\u0628\u0643 \u064a\u0627 \u062d\u0628\u064a\u060c \u0627\u0646\u062a\u0650 \u0646\u0648\u0631\u064a \u0648\u0642\u0645\u0631\u064a... \u0625\u0646 \u0634\u0627\u0621 \u0627\u0644\u0644\u0647 \u0646\u062d\u0628\u0648 \u0628\u0639\u0636\u0646\u0627 \u0644\u0644\u0623\u0628\u062f ❤️',
    completionHint: '\u0627\u0644\u0635\u0646\u062f\u0648\u0642..',
    objectives: [
      {
        id: 'l3-1',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0628\u0644\u0627\u0644',
        message: '\u0643\u0644 \u0647\u0627\u0644\u0644\u062d\u0638\u0627\u062a \u0627\u0644\u0644\u064a \u0639\u0634\u0646\u0627\u0647\u0627 \u0645\u0639 \u0628\u0639\u0636\u060c \u0627\u0639\u0631\u0641\u064a \u0627\u0646\u064a \u0646\u0639\u0632 \u0641\u064a\u0647\u0627 \u0648\u0646\u062d\u0641\u0638\u0647\u0627 \u0641\u064a \u0642\u0644\u0628\u064a.',
        points: 100,
        position: { x: 6, y: 8 },
      },
      {
        id: 'l3-2',
        title: '\u0628\u0644\u0627\u0644',
        label: '\u0628\u0644\u0627\u0644',
        message: '\u0646\u062a\u0645\u0646\u0649 \u0646\u0639\u064a\u0634 \u0645\u0639\u0627\u0643 \u0644\u062d\u0638\u0627\u062a \u0633\u0639\u064a\u062f\u0629 \u064a\u0627\u0633\u0631 \u0625\u0646 \u0634\u0627\u0621 \u0627\u0644\u0644\u0647...',
        points: 200,
        position: { x: 22, y: 8 },
      },
    ],
  },
];
